/**
 * Copies text to the clipboard. Inside the ACV iframe the async Clipboard API can be
 * blocked (permissions policy), so fall back to a hidden textarea + execCommand.
 * Resolves to false when both fail, so callers only report success when it happened.
 */
export const copyText = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    try {
      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      document.body.removeChild(el);
    }
  }
};
